var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":_vm.buttonVariant,"disabled":_vm.isButtonDisabled,"title":_vm.tooltip,"data-cy":"ping-device-btn"},on:{"click":_vm.onClick}},[_c('b',{staticClass:"pr-2"},[_vm._v("Ping Device")])])}
var staticRenderFns = []

export { render, staticRenderFns }